export class Food {
    name: string = '';
    calorieCount: Number;
    id: string = '';
}